export const confirmationConstants = {

    GET_CONFIRMATION_LIST_REQUEST: 'GET_CONFIRMATION_LIST_REQUEST',
    GET_CONFIRMATION_LIST_SUCCESS: 'GET_CONFIRMATION_LIST_SUCCESS',
    GET_CONFIRMATION_LIST_FAILURE: 'GET_CONFIRMATION_LIST_FAILURE',

    CREATE_CONFIRMATION_RANGE_REQUEST: 'CREATE_CONFIRMATION_RANGE_REQUEST',
    CREATE_CONFIRMATION_RANGE_SUCCESS: 'CREATE_CONFIRMATION_RANGE_SUCCESS',
    CREATE_CONFIRMATION_RANGE_FAILURE: 'CREATE_CONFIRMATION_RANGE_FAILURE',

    GET_CONFIRMATION_REQUEST: 'GET_CONFIRMATION_REQUEST',
    GET_CONFIRMATION_SUCCESS: 'GET_CONFIRMATION_SUCCESS',
    GET_CONFIRMATION_FAILURE: 'GET_CONFIRMATION_FAILURE',

    UPDATE_CONFIRMATION_REQUEST: 'UPDATE_CONFIRMATION_REQUEST',
    UPDATE_CONFIRMATION_SUCCESS: 'UPDATE_CONFIRMATION_SUCCESS',
    UPDATE_CONFIRMATION_FAILURE: 'UPDATE_CONFIRMATION_FAILURE',

    CREATE_CONFIRMATION_REQUEST: 'CREATE_CONFIRMATION_REQUEST',
    CREATE_CONFIRMATION_SUCCESS: 'CREATE_CONFIRMATION_SUCCESS',
    CREATE_CONFIRMATION_FAILURE: 'CREATE_CONFIRMATION_FAILURE',
    
    DELETE_CONFIRMATION_REQUEST: 'DELETE_CONFIRMATION_REQUEST',
    DELETE_CONFIRMATION_SUCCESS: 'DELETE_CONFIRMATION_SUCCESS',
    DELETE_CONFIRMATION_FAILURE: 'DELETE_CONFIRMATION_FAILURE',

}